export default __webpack_public_path__ + "static/media/Logo.2b81a064.svg";